export default __webpack_public_path__ + "static/media/chapter3.fac0f997.svg";